import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CryptoService } from '../../../core/services/crypto.service';
import { LocalStorageService } from '../../../core/services/local-storage.service';
import { CamerallaBypass } from './cameralla-bypass';
import { CamerallaLogin } from './cameralla-login';

@Injectable({
    providedIn: 'root'
})
export class CamerallaAuthService {
    public driver: any;

    constructor(private http: HttpClient, private localStorage: LocalStorageService,
                private cryptoService: CryptoService) {
        switch (environment.auth.type) {
            case 'cameralla-login':
                this.driver = new CamerallaLogin(this.http, this.localStorage, this.cryptoService);
                break;
            default:
                this.driver = new CamerallaBypass(this.localStorage, this.cryptoService);
        }
    }

    login(code) {
        return this.driver.login(code);
    }

    public logout() {
        this.localStorage.clear();
        return this.driver.logout();
    }

    public isAuthenticated() {
        return this.driver.isAuthenticated();
    }

    public getLocalUserInfo() {
        return this.driver.getLocalUserInfo();
    }

    public getUserInfo() {
        return this.localStorage.getItem('dataUser') ?
            JSON.parse(this.localStorage.getItem('dataUser')) : null;
    }
}
